import type { Media } from '../../../lib/flotiq-client/types/api-response';
import type {
  LockFormFn,
  ReloadContentObjectFn,
} from '../../../lib/flotiq-plugins/plugin-events/MediaFormAddElementEvent';

import { use } from 'react';

import { MediaFormAddElementEvent } from '../../../lib/flotiq-plugins/plugin-events/MediaFormAddElementEvent';

import ElementFromPlugin from '../../../components/ElementFromPlugin/ElementFromPlugin';

import usePluginResults from '../../../hooks/usePluginResults';

import ContentObjectFormContext from '../../../contexts/ContentObjectFormContext';

import { useFormApi } from '../../useFormApi';

interface CustomMediaFormElementProps {
  /**
   * Media being edited
   */
  media: Media;
  /**
   * If form is disabled
   */
  disabled: boolean;
  /**
   * Locks fields and saving of the form
   */
  lockForm: LockFormFn;
  /**
   * Fetches the media again
   */
  reloadContentObject: ReloadContentObjectFn;
}

const CustomMediaFormElement = ({
  media,
  disabled,
  lockForm,
  reloadContentObject,
}: CustomMediaFormElementProps) => {
  const { contentType } = use(ContentObjectFormContext);
  const form = useFormApi();

  /**
   * @emits FlotiqPlugins."flotiq.media.form::add"
   */
  const pluginRenders = usePluginResults(
    'flotiq.media.form::add',
    MediaFormAddElementEvent,
    {
      contentType,
      contentObject: media,
      form,
      disabled,
      lockForm,
      reloadContentObject,
    },
  );

  return pluginRenders?.length ? (
    <ElementFromPlugin results={pluginRenders} />
  ) : null;
};

export default CustomMediaFormElement;
